import { useEffect } from "react";
import { DEFAULT_TITLE } from "./useCanonical";

export const DEFAULT_DESCRIPTION =
  "The Tea List is an independent tea journal written in Melbourne for tea drinkers across Australia and New Zealand — brewing guides, tea types, origins and honest reviews.";

export const setMeta = (selector, value) => {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, key, val] = selector.match(/\[([^=]+)="([^"]+)"\]/) || [];
    if (key && val) el.setAttribute(key, val);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export const setJsonLd = (id, payload) => {
  let el = document.getElementById(id);
  if (!payload) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(payload);
};

/** Page-level <title>, description, OG/Twitter copy, robots and optional JSON-LD. */
export default function usePageMeta({ title, description, noindex = false, jsonLd = null, ogType = "website" }) {
  const jsonLdKey = jsonLd ? JSON.stringify(jsonLd) : null;
  useEffect(() => {
    const t = title || DEFAULT_TITLE;
    const d = description || DEFAULT_DESCRIPTION;
    document.title = t;
    setMeta('meta[name="description"]', d);
    setMeta('meta[property="og:title"]', t);
    setMeta('meta[property="og:description"]', d);
    setMeta('meta[property="og:type"]', ogType);
    setMeta('meta[name="twitter:title"]', t);
    setMeta('meta[name="twitter:description"]', d);
    setMeta('meta[name="robots"]', noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    setJsonLd("ld-page", jsonLdKey ? JSON.parse(jsonLdKey) : null);
    return () => {
      document.title = DEFAULT_TITLE;
      setMeta('meta[name="description"]', DEFAULT_DESCRIPTION);
      setMeta('meta[name="robots"]', "index, follow, max-image-preview:large");
      setJsonLd("ld-page", null);
    };
  }, [title, description, noindex, ogType, jsonLdKey]);
}
